import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';

import AsideView from '@uicomponents/AsideView';

import ConsignmentForm from './ConsignmentForm';

class ConsignmentFormPage extends Component {
  render() {
    const { t, headerName } = this.props;
    return (
      <AsideView>
        <div className="step-form">
          <form className="form active no-padding-top">
            <h1 className="center">
              {headerName ? headerName : t('consignment.create.header')}
            </h1>
            <ConsignmentForm {...this.props} />
          </form>
        </div>
      </AsideView>
    );
  }
}
export default withTranslation('translation')(ConsignmentFormPage);
